import React, { Fragment, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ListOptions from '../FindMyPart/ListOptions';
import { getVariantData, getOptions } from '../../Actions/FindMyPart.action';
import { translate } from '../../Services/translation';

const MiniFindMyPartOptionsPsg = ({ baseProductSystemId, psgSearchItems }) => {
  const dispatch = useDispatch();
  const brandsRef = useRef();
  const modelsRef = useRef();
  const unitRef = useRef();
  const sagRef = useRef();
  const ridersWeightRef = useRef();
  const shockRef = useRef();
  const [selectedBrand, setSelectedBrand] = useState({});
  const [selectedModel, setSelectedModel] = useState({});
  const [selectedUnit, setSelectedUnit] = useState({});
  const [selectedSag, setSelectedSag] = useState(-1);
  const [selectedRidersWeight, setSelectedRidersWeight] = useState(-1);
  const [selectedShock, setSelectedShock] = useState({});
  const [lastChangedOptionType, setLastChangedOptionType] = useState();
  const [searchActive, setSearchActive] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [lastSearchObj, setLastSearchObj] = useState({});
  const [isSettingModel, setIsSettingModel] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [searchValue, setSearchValue] = useState();
  const getSelectedOptionsObject = () => {
    const options = {
      baseProductSystemId,
      brand: selectedBrand,
      model: selectedModel,
      year: null,
      unit: selectedUnit,
      sag: selectedSag,
      ridersWeight: selectedRidersWeight,
      shock: selectedShock,
    };
    return options;
  };
  const doSearch = (searchQuery) => {
    const foundResult =
      !searchQuery || searchQuery.length < 1 || !psgSearchItems
        ? {}
        : psgSearchItems.search(searchQuery);
    setSearchResult(foundResult);
  };
  const setResultData = (obj) => {
    const brand = optionsPsg.brands.find((x) => x.text == obj.brand);
    if (brand) {
      setSelectedBrand(brand);
      setLastSearchObj(obj);
      setLastChangedOptionType('brand');
      setIsSettingModel(true);
    }
  };
  const showVariantData = () => {
    const options = getSelectedOptionsObject();
    dispatch(getVariantData(options));
  };
  const optionsPsg = useSelector(
    (state) => state.findMyPart.options?.optionsPsg
  );
  const setIntVal = (val, type) => {
    if (type === 'sag') {
      setSelectedSag(parseInt(val ?? -1));
    } else {
      setSelectedRidersWeight(parseInt(val ?? -1));
    }
  };

  useEffect(() => {
    if (lastChangedOptionType) {
      const options = getSelectedOptionsObject();
      dispatch(getOptions(options));
    }
  }, [lastChangedOptionType, selectedBrand]);

  useEffect(() => {
    if (optionsPsg?.models.length > 0 && isSettingModel) {
      const model = optionsPsg.models.find(
        (x) => x.text == lastSearchObj.model
      );
      if (model) {
        setSelectedModel(model);
      }
      setIsSettingModel(false);
    }
  }, [optionsPsg?.models]);

  useEffect(() => {
    if (optionsPsg?.units.length > 0 && !selectedUnit?.value) {
      setSelectedUnit(optionsPsg.units[0]);
    }
  }, [optionsPsg?.units]);

  useEffect(() => {
    if (optionsPsg?.shock.length > 0 && !selectedShock?.value) {
      setSelectedShock(optionsPsg.shock[0]);
    }
  }, [optionsPsg?.shock]);

  const handleInput = (e) => {
    const val = e.target.value;
    doSearch(val);
    setSearchValue(val);
  };
  return (
    <Fragment>
      {optionsPsg && (
        <div className="row find-my-part__options-container">
          <div className=" large-11 columns">
            <div className="row">
              <div className="find-my-part__option small-12 columns">
                <label htmlFor="fmpSearch">
                  {translate('findmypart.search')}
                </label>
                <div
                  id="fmpSearch"
                  className="find-my-part__search-input-wrapper"
                >
                  <input
                    type="text"
                    className="searchInput"
                    value={searchValue || ''}
                    onChange={handleInput}
                    onFocus={() => setSearchActive(true)}
                    onBlur={() =>
                      setTimeout(() => {
                        setSearchActive(false);
                      }, 300)
                    }
                    placeholder={translate('findmypart.search')}
                  />
                  <button onClick={() => {}}></button>
                  {/* We can use the "status" to decide whether we should display the dropdown or not */}
                  {searchActive && searchResult?.length > 0 && (
                    <ul className="find-my-part__search-input-result">
                      {searchResult &&
                        searchResult.map((object, index) => (
                          <li
                            key={`result${index}`}
                            onClick={(e) => setResultData(object.item)}
                            className={`${
                              activeIndex === index ? 'active' : ''
                            }`}
                          >
                            {object.item.brand} {object.item.model_and_year}
                          </li>
                        ))}
                    </ul>
                  )}
                </div>
              </div>
              <div className="find-my-part__option small-12 columns">
                <ListOptions
                  id="fmpBrand"
                  title={translate('findmypart.brand')}
                  selectRef={brandsRef}
                  selectedOption={selectedBrand}
                  selectKey="psgBrands"
                  list={optionsPsg.brands}
                  setSelectedOption={(val) => {
                    setSelectedBrand(val);
                    setLastChangedOptionType('brand');
                  }}
                  defaultText={translate('findmypart.selectbrand')}
                />
              </div>
              <div className="find-my-part__option small-12 columns">
                <ListOptions
                  id="fmpModels"
                  title={translate('findmypart.model')}
                  selectRef={modelsRef}
                  selectedOption={selectedModel}
                  list={optionsPsg.models}
                  setSelectedOption={(val) => setSelectedModel(val)}
                  defaultText={translate('findmypart.selectmodel')}
                />{' '}
              </div>
            </div>
            {selectedModel?.value?.length > 0 &&
              selectedUnit?.value?.length > 0 && (
                <div className="row">
                  <div className="find-my-part__option small-12 columns">
                    <div
                      className="find-my-part__description-text"
                      dangerouslySetInnerHTML={{
                        __html: optionsPsg.descriptionText,
                      }}
                    />
                  </div>

                  <div className="small-12 large-8 columns">
                    <div className="row">
                      <div className="find-my-part__option small-12 medium-6 columns">
                        <ListOptions
                          id="fmpUnit"
                          title={translate('findmypart.unit')}
                          cssClass="pad-top"
                          selectRef={unitRef}
                          selectedOption={selectedUnit}
                          list={optionsPsg.units}
                          setSelectedOption={(val) => {
                            setSelectedUnit(val);
                            setLastChangedOptionType('model');
                          }}
                        />
                      </div>
                      <div className="find-my-part__option small-12 medium-6 columns">
                        <label htmlFor="fmpRiderWeight" className="pad-top">
                          {translate('findmypart.ridersweight')}
                        </label>
                        <input
                          id="fmpRiderWeight"
                          type="number"
                          className="find-my-part__select"
                          ref={ridersWeightRef}
                          placeholder={translate(
                            'findmypart.ridersweight.placeholder'
                          )}
                          min={40}
                          onChange={(e) => setIntVal(e.target.value, 'weight')}
                        />
                        <span className="find-my-part__input-unit">kg</span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="find-my-part__option small-12 medium-6 columns">
                        <label htmlFor="fmpSag">
                          {translate('findmypart.prefferedsag')}
                        </label>
                        <input
                          id="fmpSag"
                          type="number"
                          ref={sagRef}
                          className="find-my-part__select"
                          placeholder={translate(
                            'findmypart.prefferedsag.placeholder'
                          )}
                          min={15}
                          onChange={(e) => setIntVal(e.target.value, 'sag')}
                        />
                        <span className="find-my-part__input-unit">%</span>
                      </div>
                      <div className="find-my-part__option small-12 medium-6 columns">
                        <ListOptions
                          id="fmpShock"
                          title={translate('findmypart.atshock')}
                          selectRef={shockRef}
                          selectedOption={selectedShock}
                          list={optionsPsg?.shock}
                          setSelectedOption={(val) => setSelectedShock(val)}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="find-my-part__button-container columns small-12">
                        <button
                          className="wide"
                          id="fmpSubmit"
                          onClick={() => showVariantData()}
                          disabled={
                            !(
                              selectedModel?.value?.length > 0 &&
                              selectedUnit?.value?.length > 0 &&
                              selectedRidersWeight >= 40 &&
                              selectedSag >= 15 &&
                              selectedShock?.value?.length > 0
                            )
                          }
                        >
                          {translate('findmypart.optimize')}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      )}
      <button
        className="button wide"
        id="fmpSubmit"
        onClick={() => showVariantData()}
      >
        TEST
      </button>
    </Fragment>
  );
};

export default MiniFindMyPartOptionsPsg;
